import React, { PropsWithChildren } from 'react';
import shadows from '@mui/material/styles/shadows';
import { blue, grey } from '@mui/material/colors';
import { Box } from '@mui/material';

export const RevenueTabStyledContainer = ({ children }: PropsWithChildren<{}>) => (
  <Box
    sx={{
      gap: '1rem',
      display: 'grid',
      gridTemplateColumns: '1fr 30rem',

      '& *:disabled': {
        cursor: 'not-allowed',
      },

      '& .revenueCard': {
        padding: '1rem',
        borderRadius: '4px',
        boxShadow: shadows[1],
        border: `1px solid ${grey[300]}`,
        transition: 'all 0.2s ease-in-out',

        '& .revenueCardHeader': {
          display: 'flex',
          alignItems: 'center',
          marginBottom: '1rem',
          justifyContent: 'space-between',

          '& .revenueCardHeaderIconWithTitle': {
            gap: '1rem',
            display: 'flex',
            alignItems: 'center',

            '& .revenueCardHeaderIcon': {
              display: 'flex',
              padding: '0.25rem',
              backgroundColor: blue[50],
              border: `1px solid ${blue[100]}`,

              '& > svg': {
                color: blue[700],
              },
            },
          },
        },

        '&:hover': {
          boxShadow: shadows[3],
        },
      },

      '& .revenueCard-loading': {
        position: 'relative',
        overflow: 'hidden',

        '&::after': {
          content: '""',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          position: 'absolute',
          animation: 'shimmer 1.5s infinite',
          background: `linear-gradient(90deg, transparent, ${blue[50]}, transparent)`,
        },

        '@keyframes shimmer': {
          '0%': {
            transform: 'translateX(-100%)',
          },
          '100%': {
            transform: 'translateX(100%)',
          },
        },
      },

      '& .revenueProfitContent': {
        gap: '1rem',
        display: 'flex',
        flexDirection: 'column',

        '& .revenueTotalProfit': {
          padding: '0.75rem',
          borderRadius: '4px',
          backgroundColor: blue[50],
          border: `1px solid ${blue[500]}`,
        },

        '& .revenueListProfit': {
          gap: '1rem',
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr',

          '& .revenueListItemProfit': {
            padding: '0.75rem',
            borderRadius: '4px',
            backgroundColor: grey[50],
            border: `1px solid ${grey[500]}`,
          },
        },
      },

      '& .revenueEquipmentContent': {
        gap: '1rem',
        display: 'flex',
        flexDirection: 'column',

        '& .revenueEquipmentList': {
          gap: '1rem',
          display: 'flex',
          flexDirection: 'column',

          '& .revenueEquipmentInfo': {
            gap: '1rem',
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
          },
        },

        '& .revenueEquipmentTotals': {
          gap: '0.5rem',
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',

          '& .revenueEquipmentTotal': {
            padding: '0.5rem',
            borderRadius: '4px',
            backgroundColor: blue[50],
            border: `1px solid ${blue[500]}`,
          },

          '& .revenueEquipmentTotal-loading': {
            position: 'relative',
            overflow: 'hidden',
            backgroundColor: blue[50],
            '&::after': {
              content: '""',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              position: 'absolute',
              animation: 'shimmer 1.5s infinite',
              background: `linear-gradient(90deg, transparent, ${blue[100]}, transparent)`,
            },

            '@keyframes shimmer': {
              '0%': {
                transform: 'translateX(-100%)',
              },
              '100%': {
                transform: 'translateX(100%)',
              },
            },
          },
        },
      },

      '& .revenueAftermarketContent': {
        gap: '1rem',
        display: 'flex',
        flexDirection: 'column',

        '& .revenueAftermarketLoading': {
          gap: '1rem',
          height: '5rem',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          justifyContent: 'center',
        },

        '& .revenueAftermarketProductsListItem': {
          gap: '1rem',
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',

          '& .productInfoSection': {
            display: 'flex',
            flexDirection: 'column',
          },

          '& .productPriceSection': {
            gap: '1rem',
            display: 'flex',
          },
        },

        '& .revenueAftermarketTotal': {
          padding: '0.5rem',
          borderRadius: '4px',
          backgroundColor: blue[50],
          border: `1px solid ${blue[500]}`,
        },
      },
    }}
  >
    {children}
  </Box>
);
